<script lang="ts">
    import { Icon } from "svelte-awesome";
    import { plus } from 'svelte-awesome/icons';

</script>

<Icon data={plus} />